// Curated font picker — uses Google Fonts CSS for now.
// Switch to local TTFs + opentype.js when we add SVG-path text export.

export interface FontDef {
  family: string;
  category: "sans" | "serif" | "mono" | "display" | "handwriting";
  weights: number[];
}

export const FONTS: FontDef[] = [
  { family: "Inter",         category: "sans",        weights: [400, 700, 900] },
  { family: "Montserrat",    category: "sans",        weights: [400, 700, 900] },
  { family: "Poppins",       category: "sans",        weights: [400, 700, 900] },
  { family: "Raleway",       category: "sans",        weights: [400, 700] },
  { family: "Bebas Neue",    category: "display",     weights: [400] },
  { family: "Anton",         category: "display",     weights: [400] },
  { family: "Oswald",        category: "display",     weights: [400, 700] },
  { family: "Playfair Display", category: "serif",    weights: [400, 700, 900] },
  { family: "Lora",          category: "serif",       weights: [400, 700] },
  { family: "Merriweather",  category: "serif",       weights: [400, 700, 900] },
  { family: "JetBrains Mono", category: "mono",       weights: [400, 700] },
  { family: "Fira Code",     category: "mono",        weights: [400, 700] },
  { family: "Pacifico",      category: "handwriting", weights: [400] },
  { family: "Caveat",        category: "handwriting", weights: [400, 700] },
  { family: "Dancing Script", category: "handwriting", weights: [400, 700] },
];

/** Inject a Google Fonts <link> for any families we use. Call once on app boot. */
export function loadGoogleFontsCSS(families: string[] = FONTS.map((f) => f.family)) {
  const id = "lmp-google-fonts";
  if (document.getElementById(id)) return;
  const param = families
    .map((f) => `family=${encodeURIComponent(f)}:wght@400;700;900`)
    .join("&");
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?${param}&display=swap`;
  document.head.appendChild(link);
}
